module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('svg', {
    staticClass: "uil-wheel",
    attrs: {
      "width": "124px",
      "height": "124px",
      "xmlns": "http://www.w3.org/2000/svg",
      "viewBox": "0 0 100 100",
      "preserveAspectRatio": "xMidYMid"
    }
  }, [_c('rect', {
    staticClass: "bk",
    attrs: {
      "x": "0",
      "y": "0",
      "width": "100",
      "height": "100",
      "fill": "none"
    }
  }), _c('circle', {
    attrs: {
      "cx": "50",
      "cy": "50",
      "r": "40",
      "fill": "none",
      "stroke-width": "20",
      "stroke": "#ffffff",
      "stroke-dasharray": "14px"
    }
  }, [_c('animate', {
    attrs: {
      "attributeName": "stroke-dashoffset",
      "from": "0",
      "to": "110",
      "begin": "0",
      "dur": "1s",
      "repeatCount": "indefinite",
      "fill": "freeze"
    }
  })])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-6e534c23"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/news/loading-icon.vue
// module id = 182
// module chunks = 4